import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withTranslation } from 'react-i18next';

import SearchStore from '../../../stores/SearchStore';
import { RTL } from 'arbitrip-common/translation/const';

function formatDistance(distance) {
	return Math.round(distance * 10) / 10;
}

class HotelAddressComponent extends React.Component {
	constructor(props) {
		super(props);
		this.state = {};
	}

	getDistanceDescription() {
		const { hotel, t } = this.props;

		if (hotel.distanceInKm && Number(hotel.distanceInKm) > 0.1) {
			return `${Number(hotel.distanceInKm).toFixed(1)} ${t('KM')}`;
		}

		if (_.get(hotel, 'research.distance_in_meters', 0) > 0) {
			return `${formatDistance(hotel.research.distance_in_meters / 1000)} ${t('KM')}`;
		}

		return null;
	}

	getAlternativeDistanceDescription() {
		const { hotel, t } = this.props;

		return hotel.alternative_distance
			? `(${formatDistance(hotel.alternative_distance.distance_in_km)} ${t('KM')} ${t('From')} ${hotel.alternative_distance.neighborhood.name})`
			: null;
	}

	getAlternativeDistanceNeighborhood() {
		const neighborhood_name = _.get(this.props.hotel, 'alternative_distance.neighborhood.name', null);
		const { t } = this.props;

		return neighborhood_name ? `${t('Near')} ${neighborhood_name}` : null;
	}

	getFullAddress() {
		const { hotel } = this.props;
		return (hotel.address + ', ' + hotel.city).toLowerCase() + (hotel.zip ? ', ' + hotel.zip.toUpperCase() : '');
	}

	render() {
		const { hotel, forceAddress, i18n, t } = this.props;
		const isRtl = i18n.dir() === RTL;

		const distance_description = this.getDistanceDescription();

		const full_address = this.getFullAddress();
		const headline = _.get(hotel, 'text_descriptions.headline', null);
		const alternative_distance_neighborhood = this.getAlternativeDistanceNeighborhood();

		const specific_search = SearchStore.isSpecificSearch();

		return (
			<div className="hotel-address">
				<div>
					<span className="full-address" title={full_address}>
						{specific_search || forceAddress
							? full_address
							: headline || alternative_distance_neighborhood || full_address}
					</span>
					{distance_description && (
						<span className={classNames('distance-description', { block: isRtl })}>
							{isRtl
								? `${distance_description} ${t(specific_search ? 'FromDestination' : 'FromCenter')}`
								: `(${distance_description} ${t(specific_search ? 'FromDestination' : 'FromCenter')})`}
						</span>
					)}
				</div>
			</div>
		);
	}
}

HotelAddressComponent.propTypes = {
	hotel: PropTypes.object.isRequired,
	forceAddress: PropTypes.bool,
};

export default withTranslation()(HotelAddressComponent);
